import template from './procedures.html';
import controller from './procedures.controller';

let proceduresComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default proceduresComponent;
